import { render } from "./DropdownBordered.vue?vue&type=template&id=9d76d184&ts=true"
import script from "./DropdownBordered.vue?vue&type=script&lang=ts"
export * from "./DropdownBordered.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__